import { Injectable, Output, EventEmitter, Directive } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';

@Directive()
@Injectable({
  providedIn: 'root'
})
export class LangService {
  currentMessage = new BehaviorSubject(null);
  isChange = false;
  // tslint:disable-next-line: no-output-native
  @Output() change: EventEmitter<boolean> = new EventEmitter();
  @Output() hitApiOnDashboard: EventEmitter<any> = new EventEmitter();
  @Output() hitApiOnNotificationPage: EventEmitter<any> = new EventEmitter();
  @Output() hitApiOnWallet: EventEmitter<any> = new EventEmitter();

  constructor(
    private http: HttpClient,
    private cookieService: CookieService
  ) { }
  changeLang() {
    this.isChange = !this.isChange;
    this.change.emit(this.isChange);
  }
  translate(q, target = '') {

    // const locale = this.cookieService.get('OBSIDIAM-LOCALE') || 'en';
    // const url = ''
    // const url = 'https://translation.googleapis.com/language/translate/v2?key=AIzaSyDW582zFZyZbzKbniC7CsEdsXrshTTFRxA';
    // return this.http.get(url + '&tl=en&sl=' + (target || locale) + '&q=' + q + '&target=' + (target || locale));
    return {}
  }
  hitApiOnDashboardOnLanguageChange() {
    this.hitApiOnDashboard.emit();
  }
  hitApiOnNotificationPageOnLanguageChange() {
    this.hitApiOnNotificationPage.emit();
  }
  hitApiOnWalletOnLanguageChange() {
    this.hitApiOnWallet.emit();
  }
}
